import { render, staticRenderFns } from "./Comp2.vue?vue&type=template&id=3ebb18db&scoped=true"
import script from "./Comp2.vue?vue&type=script&lang=ts"
export * from "./Comp2.vue?vue&type=script&lang=ts"
import style0 from "./Comp2.vue?vue&type=style&index=0&id=3ebb18db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb18db",
  null
  
)

export default component.exports